'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.screensaver.list', [])
  .controller('ScreenSaverListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/screenSaver/list/index.js